import React, {useState} from 'react'
import { connect } from 'react-redux'
import { format } from 'date-fns'
import { FaExclamationTriangle } from 'react-icons/fa'

import LgyLink from 'app/components/util/lgy-link/LgyLink'
import LgyLinkButton from 'app/components/util/lgy-link-button/LgyLinkButton'
import ReassignmentRequest from './ReassignmentRequest'
import acceptOrReassignAssignment from '../actions/acceptReassignAssignmentActions'

const PendingAssignmentsList = ({ id, header, maxWeekly, assignments, unaccepted, acceptOrReassignAssignment }) => {
  const [showReassignmentRequest, setShowReassignmentRequest] = useState(false)
  const [currentAssignment, setCurrentAssignment] = useState({})
  
  const setupReassignmentRequest = (assignment) => {
    setCurrentAssignment(assignment)
    setShowReassignmentRequest(true)
  }

  const handleReassignmentSubmit = (reasonText) => {
    acceptOrReassignAssignment(currentAssignment.id, currentAssignment.lin, false, reasonText)
  }
  
  return  <div className='assignments-list pending-assignments-list' id={id}>
    <ReassignmentRequest show={showReassignmentRequest} close={() => setShowReassignmentRequest(false)} reassign={handleReassignmentSubmit} />
    <h3>{header}</h3>
    Maximum weekly assignments: {maxWeekly}
    <br />
    Total assignments: {assignments.list ? assignments.list.length : ''}
    <table>
      <thead>
        <tr>
          <th scope='col'>LIN</th>
          <th scope='col'>Assignment Date</th>
          <th scope='col'>Appraisal Type</th>
          <th scope='col'>Property Address</th>
          <th scope='col'>{unaccepted ? 'Acknowledge or Request Reassignment' : 'Sales Contract Uploaded'}</th>
        </tr>
      </thead>
      <tbody>
        {assignments.fetching && <tr><td colSpan='5'>Loading...</td></tr>}
        {assignments.list && !assignments.error && !assignments.fetching
          && assignments.list.map(assignment =>
            <tr key={assignment.lin}>
              <th scope='row'>
                <LgyLink to={`/lgyhub/appraiser/${assignment.lin}`}>{assignment.lin}</LgyLink>
                &nbsp;
                {assignment.dispositionCode === 'S' &&
                  <span className='suspended-icon' data-info='LIN is in suspended status.'>
                    <FaExclamationTriangle color='orangered' />
                  </span>}
              </th>
              <td>{format(assignment.assignmentDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}</td>
              <td>{assignment.appraisalCode}{assignment.nadlAppraisalIndicator ? '-NADL' : ''}</td>
              <td className='property-address'>
                {assignment.streetNumber}&nbsp;{assignment.addressOne}
                {assignment.addressTwo ? <span><br />{assignment.addressTwo}</span> : ''}
                <br />
                {`${assignment.city}, ${assignment.state} ${assignment.zip}${assignment.zipPlusFour ? '-' + assignment.zipPlusFour : ''}`}
                <br />
                {assignment.county}
              </td>
              {unaccepted ? 
              <td>
                <LgyLinkButton onClick={() => acceptOrReassignAssignment(assignment.id, assignment.lin, true)}>Acknowledge Receipt</LgyLinkButton>
                <LgyLinkButton onClick={() => setupReassignmentRequest(assignment)}>Reassignment Request</LgyLinkButton>
              </td>
              :
              <td>
                {assignment.salesContractUploadIndicator === 'Y' ? 'Available' : ''}
                {assignment.salesContractUploadIndicator === 'N' ? 'Required' : ''}
                {assignment.salesContractUploadIndicator === 'Z' ? 'Required' : ''}
              </td>}
            </tr>)}
        {assignments.list && !assignments.error && !assignments.fetching && assignments.list.length < 1
          && <tr><td colSpan='5'>No assignments found.</td></tr>}
        {assignments.error && <tr><td colSpan='5'>Error: Unable to load assignments.</td></tr>}
      </tbody>
    </table>
  </div>
}

const mapDispatchToProps = { acceptOrReassignAssignment }

export default connect(null, mapDispatchToProps)(PendingAssignmentsList)
